import Layout from '../../components/Layout';
import ReviewCard from '../../components/ReviewCard';
import SectionHeading from '../../components/SectionHeading';
import { useSiteContent } from '../../content/ContentContext';

export default function ReviewsPage() {
  const {
    content: { reviews, site },
  } = useSiteContent();

  return (
    <Layout>
      <section className="bg-slate-50">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <SectionHeading eyebrow="Reviews" title={site.reviewsPageTitle} description={site.reviewsPageDescription} center />
          <div className="grid gap-6 lg:grid-cols-2">
            {reviews.map((review, index) => (
              <ReviewCard key={`${review.name}-${index}`} {...review} />
            ))}
          </div>
          <div className="mt-10 text-center">
            <a href={site.facebookReviews} target="_blank" rel="noreferrer" className="inline-flex rounded-full bg-[#0d4f12] px-6 py-3 font-bold text-white transition hover:bg-[#0a3c0e]">
              View Facebook Reviews
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
